// Trigger endpoint injection by importing each file, then re-export all hooks.
import "@/modules/client/loan-application/store/services/endpoints/get-organization-details";
import "@/modules/client/loan-application/store/services/endpoints/send-application";

export { useGetOrganizationDetailsQuery } from "@/modules/client/loan-application/store/services/endpoints/get-organization-details";
export { useSendApplicationMutation } from "@/modules/client/loan-application/store/services/endpoints/send-application";

